import { useState } from 'react';
import { MdAccessTimeFilled } from 'react-icons/md';
import JobChangeProcessStatusMenu from '../../job_change_processes/components/list/JobChangeProcessStatusMenu';
import JobChangeProcessStatusUpdateModal from '../../job_change_processes/components/modal/JobChangeProcessStatusUpdateModal';
import type { JobChangeProcess } from '../../job_change_processes/types/JobChangeProcess';
import DashboardScheduleAdjustDialog from './DashboardScheduleAdjustDialog';

type Props = {
  jobChangeProcess: JobChangeProcess;
  /** トリガーに表示する現在のステータス文言 */
  statusLabel: string;
  refetch: () => Promise<unknown>;
};

/**
 * - 中央: ステータス変更メニュー（マッチング管理画面と同じ JobChangeProcessStatusMenu を再利用）
 * - 日程調整中の行のみ: 時計アイコンボタンで日程調整ダイアログを開く
 */
export default function DashboardSelectionReminderActions({
  jobChangeProcess,
  statusLabel,
  refetch,
}: Props) {
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [scheduleOpen, setScheduleOpen] = useState(false);

  const isAdjustScheduling = jobChangeProcess.current_schedule_status === 'adjust_scheduling';

  const wrapRefetch = async () => {
    await refetch();
  };

  return (
    // 中央のアクション領域は固定幅 228px（Select 170 + gap + 時計 42）。
    // 日程調整ボタンの有無に関わらず Select の位置を揃える。
    <div className="flex w-[228px] shrink-0 items-center gap-md">
      <div className="w-[170px]">
        <JobChangeProcessStatusMenu
          jobChangeProcess={jobChangeProcess}
          statusModalOpen={() => setStatusModalOpen(true)}
          triggerLabel={statusLabel}
        />
      </div>

      {isAdjustScheduling && (
        <button
          type="button"
          aria-label="日程を調整する"
          onClick={() => setScheduleOpen(true)}
          className="flex size-[42px] shrink-0 items-center justify-center rounded-sm border border-solid border-border bg-white"
        >
          <MdAccessTimeFilled size={20} className="text-sub" aria-hidden="true" />
        </button>
      )}

      <JobChangeProcessStatusUpdateModal
        open={statusModalOpen}
        onOpenChange={setStatusModalOpen}
        jobchangeProcessesRefetch={wrapRefetch}
      />
      {scheduleOpen && (
        <DashboardScheduleAdjustDialog
          open={scheduleOpen}
          onOpenChange={setScheduleOpen}
          jobChangeProcess={jobChangeProcess}
          refetch={refetch}
        />
      )}
    </div>
  );
}
